module.exports = __webpack_public_path__ + "img/teaser_000.ddacfc1b.png";